/*

* pokud jsem na error stránce tak error text
* operační systém, verze prohlížeče
* screenshot
* files[] (base 64 file) zde bude i screenshot

 */

import html2canvas from 'html2canvas';
import { AppInfo } from '../utils/getAppInfo';
import { UzivatelRole } from '@mc/react-auth/dist/types/UzivatelRole';

async function drawToCanvas(stream: MediaStream) {
  const canvas = document.createElement('canvas');
  const video = document.createElement('video');
  video.srcObject = stream;

  // Play it.
  await video.play();

  // Draw one video frame to canvas.
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  // @ts-ignore
  canvas.getContext('2d').drawImage(video, 0, 0);

  return canvas;
}

type AppScreenshotIntResult = {
  base64Image?: string;
  error?: string;
};

export type AppScreenshot = {
  base64Image?: string;
  type?: ScreenshotType;
  errors: string[];
};

const takeScreenshotViaHtml2Canvas = async (): Promise<AppScreenshotIntResult> => {
  try {
    const screenshotTarget = document.body;
    const canvas = await html2canvas(screenshotTarget);
    const base64image = canvas.toDataURL('image/png');

    return {
      base64Image: base64image,
    };
  } catch (err) {
    return {
      error: err as string,
    };
  }
};

const takeScreenshotViaMediaDevices = async (): Promise<AppScreenshotIntResult> => {
  try {
    // Prompt user to share the tab's content.
    // @ts-ignore
    const stream = await navigator.mediaDevices.getDisplayMedia({
      // @ts-ignore
      preferCurrentTab: true,
    });
    // const [track] = stream.getVideoTracks();

    // Start cropping the self-capture video track using the CropTarget <-- Magic!
    //   await track.cropTo(cropTarget);

    const canvas = await drawToCanvas(stream);
    // canvas.toBlob(blob => {
    //   // See https://web.dev/patterns/files/save-a-file/ to save this blob locally.
    // });
    const frame = canvas.toDataURL('image/png');

    // @ts-ignore
    stream.getTracks().forEach(track => track.stop());

    return {
      base64Image: frame,
    };
  } catch (err) {
    return {
      error: err as string,
    };
  }
};

export const downloadBase64ImageImage = (base64Image: string) => {
  const a = document.createElement('a'); //Create <a>
  a.href = base64Image;
  a.download = 'Image.png'; //File name Here
  a.click(); //Downloaded file
  a.remove();
};

const formatDateToYYYYMMDDHHMMSS = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0, takže přidáme 1
  const day = String(date.getDate()).padStart(2, '0'); // Přidání nuly na začátek, pokud je den jednociferný
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
};

export const downloadJson = (data: AppInfo) => {
  const a = document.createElement('a'); //Create <a>
  const base64Str =
    'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(data));
  a.href = base64Str;
  a.download = `appinfo-${formatDateToYYYYMMDDHHMMSS(
    new Date(data.date)
  )}.json`; //File name Here
  a.click(); //Downloaded file
  a.remove();
};

export enum ScreenshotType {
  HTML2CANVAS = 'HTML2CANVAS',
  MEDIA_DEVICES = 'MEDIA_DEVICES',
}

export const takeScreenshot = async (): Promise<AppScreenshot> => {
  let mediaDevices = await takeScreenshotViaMediaDevices();

  let errors: string[] = [];

  if (mediaDevices.base64Image) {
    return {
      base64Image: mediaDevices.base64Image,
      type: ScreenshotType.MEDIA_DEVICES,
      errors,
    };
  } else {
    errors.push(
      `Take screenshot via ${ScreenshotType.MEDIA_DEVICES}: ${mediaDevices.error}`
    );
  }

  let html2canvas = await takeScreenshotViaHtml2Canvas();
  if (html2canvas.base64Image) {
    return {
      base64Image: html2canvas.base64Image,
      type: ScreenshotType.HTML2CANVAS,
      errors,
    };
  } else {
    errors.push(
      `Take screenshot via ${ScreenshotType.HTML2CANVAS}: ${html2canvas.error}`
    );
  }

  return {
    errors,
  };
};

export interface ReactAppAuthLog {
  /**
   * Login uživatele.
   */
  login?: string;
  /**
   * Jméno uživatele.
   */
  fullname?: string;
  /**
   * Id přihlášeného pracovníka.
   */
  pracovnikId?: number;
  /**
   * Jedná se o uživatele s administrátorským oprávněním.
   */
  admin?: boolean;
  /**
   * Seznam rolí (oprávnění) uživatele.
   */
  roleUzivatele?: UzivatelRole[];
  /**
   * Kód organizace přihlášeného pracovníka.
   */
  kodOrganizace?: string;
  /**
   * Seznam profilů s kterými je aplikace spuštěná (např. marbes).
   */
  appProfiles?: string[];
}

export interface ReactAppLog {
  /**
   * Název aplikace
   */
  applicationName: string;
  /**
   * Kód aplikace
   */
  applicationCode: string;
  /**
   * Kód prostředí.
   */
  envCode?: string;
  /**
   * Datum sa čas sestavení v ISO formátu, např. '2023-08-31T12:30:10.443Z'.
   */
  buildDate?: string;
  /**
   * Je aplikace puštěna v MC?
   */
  isInMC: boolean;
  /**
   * Aktuální url v prohlížeči (window.location).
   */
  url: string;
  /**
   * Verze aplikace, např. '22.0.0-SNAPSHOT'.
   */
  version: string;
  /**
   * Build number - systémová, např. '123'.
   */
  buildNumber?: string;
  /**
   * Build version - systémová.
   */
  buildVersion?: string;
  /**
   * Jedná se o testovací prostředí?
   */
  testEnvironment: boolean;
}
